import { render, staticRenderFns } from "./PopupItem.vue?vue&type=template&id=e1742b14"
import script from "./PopupItem.vue?vue&type=script&lang=js"
export * from "./PopupItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports